import { t } from 'i18next'
import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'

import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { CustomBlockData } from '../types.mod'
import { link, getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { TemplateState } from '../../../../cms/page/types.gen'
import { Link } from 'react-router-dom'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { async, AsyncState, loadingAsyncState } from 'widgets-for-react/dist/combinators/async'
import { stateful } from 'widgets-for-react/dist/combinators/stateful'
import { any } from 'widgets-for-react/dist/combinators/any'
import * as BSLEvents from '../../../../events/api'
import { List } from 'immutable'
import { loader } from '../../../templates/loader.mod'
import { DataLayer } from '../../../utils/datalayer'

export type BSLLatestEventsBlockProps = {
  key?: string
  category: string
  blocked_events: string[]
}

type BSLLatestEventsBlockState = {
  events: AsyncState<BSLEvents.Event[]>
}

export type BSLLatestEventsBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  title_classname: string
  list_classname: string
  item_classname: string
  item_link_classname: string
  item_label_classname: string
  item_title_classname: string
  item_title_text_classname: string
  item_text_classname: string
  clickable_primary_classname: string
}>

export function BSLUpcomingEventsBlock<customBlockData, extra_images>(
  props: BSLLatestEventsBlockProps,
  options?: { style?: BSLLatestEventsBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    stateful<BSLLatestEventsBlockState>()(s0 =>
      any<Action<BSLLatestEventsBlockState>>()([
        async<BSLEvents.Event[]>()(s0.events).map(a => s1 => ({ ...s1, events: a(s1.events) })),
        mk_widget({
          run: _ => {
            if (s0.events.kind == 'loaded' && s0.events.value.length <= 0) {
              return <></>
            }

            return (
              <section
                className={getClassName(options, 'block_classname', 'block')}
                key={options && options.key ? options.key : ''}
              >
                <div className={getClassName(options, 'inner_classname', 'block__inner')}>
                  <h2 className={getClassName(options, 'title_classname', '')}>Evenementen</h2>
                  <div className={getClassName(options, 'list_classname', '')}>
                    {s0.events.kind === 'loaded' ? (
                      <>
                        {s0.events.value.map((event, key) => (
                          <div className={getClassName(options, 'item_classname', '')} key={`event-${key}`}>
                            <a
                              href={event.link}
                              target="_blank"
                              className={getClassName(options, 'item_link_classname', '')}
                              onClick={() => DataLayer.clickToEvent(event.link)}
                            >
                              <span className={getClassName(options, 'item_label_classname', '')}>
                                {t('events.sources.' + event.source)}
                              </span>
                              <h2 className={getClassName(options, 'item_title_classname', '')}>
                                <span className={getClassName(options, 'item_title_text_classname', '')}>
                                  {event.title}
                                </span>
                              </h2>
                              <p className={getClassName(options, 'item_text_classname', '')}>
                                {[
                                  event.startDate ? event.startDate.format('LL') : undefined,
                                  event.location.toString().length > 0 ? event.location : undefined
                                ]
                                  .filter(e => e)
                                  .map((e, i) => (
                                    <span>
                                      {i > 0 ? ' | ' : ''}
                                      {e}
                                    </span>
                                  ))}
                              </p>
                            </a>
                          </div>
                        ))}
                      </>
                    ) : (
                      Array(4)
                        .fill(null)
                        .map((_, index) => (
                          <div className={getClassName(options, 'item_classname', '')} key={index}>
                            <div className={getClassName(options, 'item_link_classname', '')}>
                              <div style={{ minHeight: 70 }}>{loader.run(() => null)}</div>
                            </div>
                          </div>
                        ))
                    )}
                  </div>
                </div>
              </section>
            )
          }
        })
      ]).map(a => a(s0))
    )({ events: loadingAsyncState(() => BSLEvents.getEvents(props.category, 4, props.blocked_events)) }).map(a => s =>
      s
    )
}
